/**
 * Shared a11y-dialog instance provided by the theme vendor script
 * (cannabuilder-a11y-dialog → dist/a11y-dialog.js → window.A11yDialog).
 *
 * Resolve the constructor at `new` time so WP Rocket defer/delay cannot
 * snapshot `undefined` when age-gate.js evaluates before a11y-dialog.js.
 */
function createMissingDialogStub() {
	const stub = {
		on() {
			return stub;
		},
		off() {
			return stub;
		},
		show() {
			return stub;
		},
		hide() {
			return stub;
		},
		destroy() {
			return stub;
		},
	};
	return stub;
}

function A11yDialog(...args) {
	const Ctor = typeof window !== 'undefined' ? window.A11yDialog : undefined;
	if (typeof Ctor !== 'function') {
		console.error('A11yDialog vendor script did not load');
		return createMissingDialogStub();
	}
	return new Ctor(...args);
}

export default A11yDialog;
